import React from 'react'
import CustomNavbar from './PublicNavbar'
import ForgotPasswordForm from '../../components/form/SignUp/ForgotPasswordForm'

export default function ForgotPassword() {
    return (
        <>
            <CustomNavbar />

            <div className="signup-page">
                <div className="signup-form-container">
                    <ForgotPasswordForm />
                </div>

            </div>
        </>
    )
}
